import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, deepPurpleMui, greyMui, rydeColors } from "@ryde/theme";

export const CoursesPanelTopWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "courses-panel-top-wrapper",
})`
  min-width: 100%;
  margin-bottom: 0;
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
  .top_grid_settings_line {
    width: 100%;
    min-height: 30px;
    padding-inline: 26px 15px;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .top_grid_settings_line__left {
    display: inline-flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  .courses-calendar-toolbar-select {
    .MuiInput-root {
      font-size: 13px;
    }

    .MuiSelect-select {
      padding-right: 28px;
    }

    &.MuiFormControl-root::before,
    &.MuiFormControl-root::after {
      border-color: ${deepPurpleMui.A700};
    }

    .MuiInput-root::before {
      border-bottom-color: ${deepPurpleMui.A700};
    }

    .MuiInput-root:hover:not(.Mui-disabled)::before {
      border-bottom-color: ${deepPurpleMui.A700};
    }

    .MuiInput-root::after {
      border-bottom-color: ${deepPurpleMui.A700};
    }
  }

  .courses-calendar-toolbar-select--rides {
    min-width: 220px;
  }

  .courses-calendar-toolbar-select--rows {
    min-width: 170px;
  }

  .top_grid_settings_line__right {
    display: inline-flex;
    align-items: center;
    gap: 18px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

export const CoursesSlotStatsStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "courses-calendar-slot-stats",
})`
  display: inline-flex;
  align-items: baseline;
  gap: 22px;
  font-size: 13px;
  line-height: 1.2;
  white-space: nowrap;

  .courses-slot-stats__pair {
    display: inline-flex;
    align-items: baseline;
    gap: 5px;
  }

  .courses-slot-stats__label {
    color: ${blueGreyMui._600};
    font-weight: 500;
  }

  .courses-slot-stats__value {
    color: ${deepPurpleMui.A700};
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    min-width: 1.25ch;
  }
`;

export const CalendarCoursesPanelBodyStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "courses-calendar-panel-body",
  },
)`
  height: 100%;
  min-height: 480px;
  margin-top: 3px;
  position: relative;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);
  border-top: 1px solid ${greyMui.A100};
  border-bottom: 1px solid ${greyMui.A100};
`;
